import { getApiActionTypes } from '../../../../shared/store/storeHelpers';

export const fetchFederalReconciliationVariancesTypes = getApiActionTypes(
  'FETCH_FEDERAL_RECONCILIATION_VARIANCES',
);
